import ApiService from "../../common/apiService";
import { getData } from "../../common/dataHelper";
import { COURSE_TYPES, LECTURER_TYPES } from "../types";

const state = {
  courses: [],
  participants: [],
  participant: null,
};

const getters = {
  [LECTURER_TYPES.GET_COURSES](state) {
    return state.courses;
  },
  [LECTURER_TYPES.GET_PARTICIPANTS](state) {
    return state.participants;
  },
  [LECTURER_TYPES.GET_PARTICIPANT](state) {
    return state.participant;
  },
};

const actions = {
  async [LECTURER_TYPES.FETCH_COURSES]({ commit }) {
    const response = await ApiService.query("academy/lecturer");
    const courses = getData(response, "data.courses");

    if (courses) {
      commit(COURSE_TYPES.SET_COURSES, courses);
    }

    return response;
  },
  async [LECTURER_TYPES.FETCH_PARTICIPANTS]({ commit }, { courseId }) {
    const response = await ApiService.query(
      `academy/lecturer/courses/${courseId}`
    );
    const participants = getData(response, "data.courseCustomers");

    if (participants) {
      commit(LECTURER_TYPES.SET_PARTICIPANTS, participants);
    }

    return response;
  },
  async [LECTURER_TYPES.FETCH_PARTICIPANT](
    { commit },
    { courseId, customerId }
  ) {
    const response = await ApiService.query(
      `academy/lecturer/courses/${courseId}/customer/${customerId}`
    );
    const participant = getData(response, "data.customer");

    if (participant) {
      commit(LECTURER_TYPES.SET_PARTICIPANT, participant);
    }

    return response;
  },
  async [LECTURER_TYPES.UPDATE_PARTICIPANT_EXAM_STATUS](
    context,
    { courseId, customerId, examPassed }
  ) {
    const response = await ApiService.put(
      `academy/lecturer/courses/${courseId}/customer/${customerId}`,
      { exam_passed: examPassed }
    );
    return response;
  },
};

const mutations = {
  [LECTURER_TYPES.SET_COURSES](state, courses) {
    state.courses = courses;
  },
  [LECTURER_TYPES.SET_PARTICIPANTS](state, participants) {
    state.participants = participants;
  },
  [LECTURER_TYPES.SET_PARTICIPANT](state, participant) {
    state.participant = participant;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
